import { useTranslation } from 'react-i18next'

export const useGetCurrencySymbol = () => {
  const { i18n } = useTranslation()
  const currentLocale = i18n.resolvedLanguage || i18n.language

  return (currency: string | null | undefined, fallback = '--') => {
    if (typeof currency !== 'string') {
      return fallback
    }

    return new Intl.NumberFormat(currentLocale, { style: 'currency', currency })
      .formatToParts(1)
      .find(x => x.type === 'currency').value
  }
}
